/**
 * Product page – sticky anchor bar
 * Smooth scroll + active state on scroll
 */
(() => {
  const anchor = document.querySelector("[data-product-anchor]");
  if (!anchor) return;

  const links = [...anchor.querySelectorAll(".product-anchor__link")];
  const sections = links
    .map((link) => document.getElementById(link.dataset.anchor))
    .filter(Boolean);

  if (!sections.length) return;

  const root = document.documentElement;

  const syncAnchorHeight = () => {
    root.style.setProperty("--product-anchor-height", `${anchor.offsetHeight}px`);
  };

  const getHeaderHeight = () => {
    if (document.body.classList.contains("shopify-section-header-hidden")) {
      return 0;
    }
    const raw = getComputedStyle(root).getPropertyValue("--header-height").trim();
    const parsed = Number.parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getScrollOffset = () => getHeaderHeight() + anchor.offsetHeight;

  const setActive = (id) => {
    links.forEach((link) => {
      const isActive = link.dataset.anchor === id;
      link.classList.toggle("is-active", isActive);
      if (isActive) {
        link.setAttribute("aria-current", "true");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  };

  const getActiveSectionId = () => {
    const offset = getScrollOffset() + 1;
    const scrollPos = window.scrollY + offset;
    let currentId = sections[0].id;

    sections.forEach((section) => {
      if (section.offsetTop <= scrollPos) {
        currentId = section.id;
      }
    });

    return currentId;
  };

  const scrollToSection = (section, updateHash = true) => {
    const top = section.getBoundingClientRect().top + window.scrollY - getScrollOffset();
    window.scrollTo({ top, behavior: "smooth" });
    if (updateHash) {
      history.replaceState(null, "", `#${section.id}`);
    }
    setActive(section.id);
  };

  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const target = document.getElementById(link.dataset.anchor);
      if (!target) return;
      scrollToSection(target);
    });
  });

  let ticking = false;

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      setActive(getActiveSectionId());
      ticking = false;
    });
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => {
    syncAnchorHeight();
    onScroll();
  });

  syncAnchorHeight();

  const initialHash = window.location.hash.slice(1);
  const initialSection = initialHash
    ? document.getElementById(initialHash)
    : sections[0];

  if (initialSection && sections.includes(initialSection)) {
    setActive(initialSection.id);
    if (initialHash) {
      window.requestAnimationFrame(() => {
        scrollToSection(initialSection, false);
      });
    }
  } else {
    setActive(sections[0].id);
  }

  onScroll();
})();
